export default __webpack_public_path__ + "static/media/Linkedin Learning Path Network+ prep.44ed2289.webp";